/* eslint-disable complexity */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import moment from 'moment'

import {
    Button,
    Bons,
} from 'react-wot-bootstrap'
import { playClansWinnerRewardMakeBet } from 'state/actions/sounds'
import ButtonGhost from 'components/ButtonGhost/ButtonGhost'
import FamePoints from 'components/FamePoints/FamePoints'
import TankAuctionSlider from '../TankAuctionSlider/TankAuctionSlider'
import {
    RewardsMetaPropTypes,
    BalancePropTypes,
} from 'containers/WGCWXShop/propTypes'

import {
    AFFIRMATIVE,
    TANK_IS_ALREADY_IN_HANGAR,
    TANK_IS_ALREADY_SELECTED,
    TANK_IS_ALREADY_PURCHASED,
    WG_MONEY_UNAVAILABILE,
    ENOUGH_PFP,
    TOP_BEST_COUNT,
    PURCHASE_REWARD,
    TO_CHANGE,
    WARNING_MESSAGE_NOT_ENOUGH_BONS,
    WARNING_MESSAGE_NOT_ENOUGH_BONS_FOR_PURCHASE,
    NOT_ENOUGH_PFP,
    MINIMAL_RATE,
    EVENT_NOT_FINISHED_NO_AUCTION_TICKET,
    EVENT_NOT_FINISHED_HAS_AUCTION_TICKET,
    BET_ACCEPTED,
    BET_LOST,
    YOUR_BET,
    CANCEL_BET,
    MAKE_BET,
    MAKE_BET_TEXT,
    EVENT_FINISHED_NO_AUCTION_TICKET,
} from './translations'

import styles from './Footer.scss'

export class Footer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            footerState: this.defineFooterState(props),
        }
    }

    handleMakeBet = () => {
        this.props.playClansWinnerRewardMakeBet()
        this.props.makeBetHandler()
    }

    defineFooterState = (props) => {
        const {
            inHangar,
            isSelected,
            meta,
            price, // bons
            wgMoneyServiceError,
            anyTankSelected,
            pfpPrice,
            accountBalance: { crystal },
        } = props

        const {
            famePoints,
            minBet,
            currentBet,
            hasAuctionTicket,
        } = meta

        switch (true) {
        case inHangar && !isSelected:
            return 'rewardInHangar' // reward was in hangar before event

        case inHangar && isSelected || !inHangar && isSelected && !currentBet:
            /* purchasing reward:
                reward selected and given
                reward selected but not given yet and it isn't bet
            */
            return 'rewardPurchased'
        case !inHangar && !isSelected && anyTankSelected:
            return 'rewardSelected' // open reward can't be selected because another reward selected

        case !pfpPrice && !hasAuctionTicket:
            return 'eventNotFinishedNoAuctionTicket'

        case !pfpPrice && hasAuctionTicket:
            return 'eventNotFinishedHasAuctionTicket'

        case pfpPrice && wgMoneyServiceError:
            return 'wgMoneyUnavailable' // event finished and wgm error

        case pfpPrice && (famePoints >= pfpPrice) && (crystal >= price):
            return 'enoughPfpEnoughBonds' // player has enough pfp and bons to purchase this reward

        case pfpPrice && (famePoints >= pfpPrice) && (crystal < price) && !currentBet:
            // player has enough pfp but few bons to purchase this reward and bet not accepted

            return 'enoughPfpNotEnoughBonds'

        case pfpPrice && !hasAuctionTicket && !currentBet:
            return 'eventFinishedNoAuctionTicket'

        case pfpPrice && (famePoints < pfpPrice) && (crystal < minBet) && !currentBet:
            // player hasn't enough bons to make bet and bet not accepted
            return 'notEnoughPfpNotEnoughBonds'

        case Boolean(currentBet):
            return 'betAccepted'

        default:
            return 'makeBet'
        }
    }

    render() {
        const { footerState } = this.state
        const {
            onCloseHandler,
            openTankPurchaseConfirmationHandler,
            openCancelBetConfirmationHandler,
            handleBetChangeHandler,
            price,
            bet,
            meta,
            pfpPrice,
            accountBalance: { crystal },
        } = this.props

        const {
            places,
            minBet,
            currentBet,
            purchaseDatetimeEnd,
        } = meta

        const datetimeEnd = moment.utc(purchaseDatetimeEnd).local()
        const footerClassName = classnames(
            styles.footer,
            styles[`footer__${footerState}`]
        )

        const footerIconClassName = classnames(
            styles.footerIcon,
            styles[`footerIcon__${footerState}`]
        )

        if (footerState === 'rewardInHangar') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={footerIconClassName} />
                            <div className={styles.text}>{TANK_IS_ALREADY_IN_HANGAR}</div>
                        </div>
                        <div className={styles.action}>
                            <Button
                                onClick={onCloseHandler}
                                mixClassName={styles.buttonAfirmative}
                            >
                                {AFFIRMATIVE}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }

        if (footerState === 'rewardSelected') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={footerIconClassName} />
                            <div className={styles.text}>{TANK_IS_ALREADY_SELECTED}</div>
                        </div>
                        <div className={styles.action}>
                            <Button
                                onClick={onCloseHandler}
                                mixClassName={styles.buttonAfirmative}
                            >
                                {AFFIRMATIVE}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }

        if (footerState === 'rewardPurchased') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={styles.text}>{TANK_IS_ALREADY_PURCHASED}</div>
                        </div>
                        <div className={styles.action}>
                            <Button
                                onClick={onCloseHandler}
                                mixClassName={styles.buttonAfirmative}
                            >
                                {AFFIRMATIVE}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }

        if (footerState === 'wgMoneyUnavailable') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={footerIconClassName} />
                            <div className={styles.text}>{WG_MONEY_UNAVAILABILE}</div>
                        </div>
                        <div className={styles.action}>
                            <Button
                                onClick={onCloseHandler}
                                mixClassName={styles.buttonAfirmative}
                            >
                                {AFFIRMATIVE}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }

        if (footerState === 'enoughPfpEnoughBonds') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={styles.text}>
                                {ENOUGH_PFP(
                                    <span className={styles.top_count}>{TOP_BEST_COUNT(places)}</span>,
                                )}
                            </div>
                        </div>
                        <div className={styles.action}>
                            <div className={styles.toChangeText}>{TO_CHANGE}</div>
                            <div className={styles.footerBons}>
                                <Bons
                                    size="large"
                                    iconPosition="after"
                                    value={price}
                                />
                            </div>
                            <div className={styles.footerFamePoints}>
                                <FamePoints value={pfpPrice} />
                            </div>
                            <div className={styles.buttonAction}>
                                <Button
                                    type="primary"
                                    onClick={openTankPurchaseConfirmationHandler}
                                    mixClassName={styles.buttonPurchase}
                                >
                                    {PURCHASE_REWARD}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        if (footerState === 'enoughPfpNotEnoughBonds') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={styles.text}>
                                {ENOUGH_PFP(
                                    <span className={styles.top_count}>{TOP_BEST_COUNT(places)}</span>,
                                )}
                            </div>
                        </div>
                        <div className={styles.action}>
                            <div className={styles.warningMessage}>{WARNING_MESSAGE_NOT_ENOUGH_BONS_FOR_PURCHASE}</div>
                            <div className={styles.toChangeText}>{TO_CHANGE}</div>
                            <div className={styles.footerBons}>
                                <Bons
                                    size="large"
                                    iconPosition="after"
                                    value={price}
                                    isNotEnough
                                />
                            </div>
                            <div className={styles.footerFamePoints}>
                                <FamePoints value={pfpPrice} />
                            </div>
                            <div className={styles.buttonAction}>
                                <Button
                                    onClick={onCloseHandler}
                                    mixClassName={styles.buttonAfirmative}
                                >
                                    {AFFIRMATIVE}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        if (footerState === 'notEnoughPfpNotEnoughBonds') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={styles.text}>
                                {NOT_ENOUGH_PFP}
                            </div>
                        </div>
                        <div className={styles.action}>
                            <div className={styles.warningMessage}>
                                <span className={styles.text}>{WARNING_MESSAGE_NOT_ENOUGH_BONS}</span>
                                <span>{MINIMAL_RATE}</span>
                            </div>
                            <div className={styles.footerBons}>
                                <Bons
                                    size="large"
                                    iconPosition="after"
                                    value={minBet}
                                    isNotEnough
                                />
                            </div>
                            <div className={styles.action}>
                                <Button
                                    onClick={onCloseHandler}
                                    mixClassName={styles.buttonAfirmative}
                                >
                                    {AFFIRMATIVE}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        if (footerState === 'eventNotFinishedNoAuctionTicket') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={styles.text}>
                                {EVENT_NOT_FINISHED_NO_AUCTION_TICKET(
                                    <span className={styles.top_count}>{TOP_BEST_COUNT(places)}</span>,
                                )}
                            </div>
                        </div>
                        <div className={styles.action}>
                            <Button
                                onClick={onCloseHandler}
                                mixClassName={styles.buttonAfirmative}
                            >
                                {AFFIRMATIVE}</Button>
                        </div>
                    </div>
                </div>
            )
        }

        if (footerState === 'eventFinishedNoAuctionTicket') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={styles.text}>
                                {EVENT_FINISHED_NO_AUCTION_TICKET}
                            </div>
                        </div>
                        <div className={styles.action}>
                            <Button
                                onClick={onCloseHandler}
                                mixClassName={styles.buttonAfirmative}
                            >
                                {AFFIRMATIVE}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }

        if (footerState === 'eventNotFinishedHasAuctionTicket') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={styles.text}>
                                {EVENT_NOT_FINISHED_HAS_AUCTION_TICKET}
                            </div>
                        </div>
                        <div className={styles.action}>
                            <Button
                                onClick={onCloseHandler}
                                mixClassName={styles.buttonAfirmative}
                            >
                                {AFFIRMATIVE}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }

        if (footerState === 'betAccepted') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={styles.text}>
                                {BET_ACCEPTED(datetimeEnd)}
                                {BET_LOST}
                            </div>
                        </div>
                        <div className={styles.action}>
                            <div className={styles.yourBetText}>{YOUR_BET}</div>
                            <div className={styles.footerBons}>
                                <Bons
                                    size="large"
                                    iconPosition="after"
                                    value={currentBet}
                                />
                            </div>
                            <div className={styles.cancelBetWrapper}>
                                <ButtonGhost
                                    onClick={openCancelBetConfirmationHandler}
                                    mixClassName={styles.buttonCancelBet}
                                >
                                    {CANCEL_BET}
                                </ButtonGhost>
                            </div>
                            <Button
                                onClick={onCloseHandler}
                                mixClassName={styles.buttonAfirmative}
                            >
                                {AFFIRMATIVE}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }

        if (footerState === 'makeBet') {
            return (
                <div className={footerClassName}>
                    <div className={styles.wrapperContainer}>
                        <div className={styles.textBlock}>
                            <div className={styles.text}>
                                {MAKE_BET}
                            </div>
                        </div>
                        <div className={styles.action}>
                            <div className={styles.yourBetText}>{YOUR_BET}</div>
                            <TankAuctionSlider
                                currentValue={bet}
                                minValue={minBet}
                                maxValue={crystal}
                                handleChange={handleBetChangeHandler}
                            />
                            <Button
                                mixClassName={styles.buttonMakeBet}
                                isPending={this.props.actionInProgress}
                                type="primary"
                                onClick={this.handleMakeBet}
                            >
                                {MAKE_BET_TEXT}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }
        return null
    }
}

/* eslint-disable react/no-unused-prop-types */
Footer.propTypes = {
    onCloseHandler: PropTypes.func.isRequired,
    openTankPurchaseConfirmationHandler: PropTypes.func.isRequired,
    openCancelBetConfirmationHandler: PropTypes.func.isRequired,
    makeBetHandler: PropTypes.func.isRequired,
    handleBetChangeHandler: PropTypes.func.isRequired,
    bet: PropTypes.number.isRequired,
    meta: RewardsMetaPropTypes,
    inHangar: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    price: PropTypes.number.isRequired,
    pfpPrice: PropTypes.number.isRequired,
    wgMoneyServiceError: PropTypes.bool.isRequired,
    actionInProgress: PropTypes.bool.isRequired,
    accountBalance: BalancePropTypes,
    anyTankSelected: PropTypes.bool.isRequired,
    playClansWinnerRewardMakeBet: PropTypes.func.isRequired,
}
/* eslint-enable */

const mapStateToProps = state => {
    return {
        actionInProgress: state.wgcwxShopRewards.processing,
    }
}

export const mapDispatchToProps = {
    playClansWinnerRewardMakeBet,
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/Footer.jsx